export type { BadgeProps } from '../../types/badge';
export { Badge } from './adapters/inbound/Badge';
